import {createSlice} from "@reduxjs/toolkit";
import moment from "moment";

const currentTime = moment().format("HH:mm");

export const newBuysInitialValue = {
    documentType: "",
    documentTypeName: "",
    myDataType: "",
    date: null,
    time: currentTime,
    customTime: "false",
    installation: "",
    preNumber: "",
    numberingMode: "manual",
    number: "",
    corelatedDocument: "",
    supplier: "",
    supplierName: "",
    employee: "",
    employeeName: "",
    supplierInstallationId: 0,
    supplierInstallationType: "",
    supplierCode: "",
    newSupplier: "",
    email: "",
    phone: "",
    supplierType: "Existing", // Existing or New
    vat: "",
    address: "",
    doy: "",
    city: "",
    pc: "",
    paymentType: "",
    paymentTypeName: "",
    myDataPaymentId: "",
    bankAccount: "",
    buyPurpose: "",
    specialInvoiceCategory: "",
    products: [],
    extraData: {
        wayOfSendingGoods: "",
        wayOfSendingGoodsName: "",
        carNumber: "",
        carNumberName: "",
        goodsSendDate: "",
        otherTax: "",
        otherTaxEuro: "",
        withHoldTax: "",
        withHoldTaxEuro: "",
        fee: "",
        feeEuro: "",
        stamp: "",
        stampEuro: "",
        deliveryLocation: "companyLocation",
        locationAddress: "",
        locationCity: "",
        locationCountry: "",
        locationZip: "",
        cashRegister: "",
        isTriangularTrade: "false"
    },
    notes: "",
    buysTaxes: [],
    otherCorrelatedEntities: [],
    totalQuantity: 0,
    totalBeforeDiscount: 0,
    totalDiscount: 0,
    totalNetValue: 0,
    totalVatValue: 0,
    totalAmount: 0,
    paymentAmount: 0,
    sendMailOnSave: "inactive",
    myDataStatus: "not_sent",
    transmissionFailure: "",
    documentCategory: "Initial Document",
    isDeliveryNote: false,
}

export const newBuysNewProductInitialValue = {
    no: "",
    id: 0,
    code: "",
    name: "",
    quantity: 1,
    mu: "",
    unitPrice: "",
    discount: "",
    isPerDiscount: "false",
    isDiscountAmount: "true",
    fee: "",
    feeEuro: "",
    otherTax: "",
    otherTaxEuro: "",
    stamp: "",
    stampEuro: "",
    withHoldTax: "",
    withHoldTaxEuro: "",
    taxes: "",
    vatPercentage: "",
    vatId: "",
    vatReason: "",
    vatType: "",
    vat: "",
    netValue: "",
    totalValue: "",
    _id: ""
}

export const defaultMyDataReportRequestData = {
    date_from: moment().startOf("month").format("DD/MM/YYYY"),
    date_to: moment().endOf("month").format("DD/MM/YYYY"),
    supplierVAT: "",
    number_from: "",
    number_to: "",
    invoiceType: [],
    aiStatus: [],
    totalSum_from: "",
    totalSum_to: "",
    reportType: "buys",
    showFilter: "all",
    showSuppliers: false,
    showAccounting: true,
    page: 1,
    totalPages: 0,
    totalItems: 0,
    lastUpdate: "",
    canFetchClassifications: false,
    classified: "",
    marks: "",
    classificationTypes: [],
    invoicesFromChannel: "all",
}

const initBuysBalanceSheetRequestData = {
    firstLoad: true,
    page: 1,
    date_from: "",
    date_to: "",
    supplierName: "",
    supplierId: "",
    invoiceType: [],
    paymentType: [],
    specialFilter: [],
    carNumber: [],
    amountFrom: "",
    amountTo: "",
    preNumberFrom: "",
    preNumberTo: "",
    numberFrom: "",
    numberTo: "",
    notes: "",
    installation: "",

    totalPages: 0,
    totalVatValue: 0,
    totalNetValue: 0,
    totalValue: 0,
    totalNonDeductibleVAT: 0,
}

const initSupplierPaymentReportRequestData = {
    firstLoad: true,
    date_from: "",
    date_to: "",
    amountFrom: "",
    amountTo: "",
    page: 1,
    supplierName: "",
    invoiceType: [],
    paymentType: [],
}

const initSupplierPaymentReportResponseData = {
    totalPages: 0,
    data: [],
    totalPaymentAmount: 0,
}

const initBuysGraphicReportRequestData = {
    firstLoad: true, // For date setup
    date_from: "",
    date_to: "",
    supplierId: "",
    supplierName: "",
    paymentType: [],
}

const initBuysGraphicReportResponseData = {
    data: [],
}

const initBuysMonthlyTurnoverRequestData = {
    page: 1,
    date_from: "",
    date_to: "",
    supplierName: "",
}

const initBuysMonthlyTurnoverResponseData = {
    totalPages: 0,
    data: [],
    totalPaymentAmount: 0,
}

const initialState = {
    buys: [],
    searchBuys: [],
    totalItemsBS: 0,
    perPageBS: 0,
    buysTemplates: [],
    newBuysInitialValue: newBuysInitialValue,
    newBuys: newBuysInitialValue,
    newBuyAutofill: null,
    newBuysNewProductInitialValue: newBuysNewProductInitialValue,
    newBuysNewProduct: newBuysNewProductInitialValue,
    editBuys: newBuysInitialValue,
    editBuysNewProductInitialValue: newBuysNewProductInitialValue,
    editBuysNewProduct: newBuysNewProductInitialValue,
    corelatedDocumentsList: [],

    newBuySupplierCustomData: {
        supplierVatCategory: "Normal VAT",
        supplierVatReason: "",
        supplierCustomVat: 0,
    },

    editBuySupplierCustomData: {
        supplierVatCategory: "Normal VAT",
        supplierVatReason: "",
        supplierCustomVat: 0,
    },

    // Buys Balance Report
    buysBalanceReportRequestData: {},
    buysBalanceReportData: {},

    // Buys Monthly Turnover Report
    buysMonthlyTurnoverReportRequestData: {},
    buysMonthlyTurnoverReportData: {},

    // Buys My Data Report
    forceRefreshMyDataBuysReport: "",
    defaultMyDataReportRequestData: defaultMyDataReportRequestData,
    myDataReportRequestData: defaultMyDataReportRequestData,
    buysMyDataReportData: [],
    buysMyDataReportSuppliersData: [],
    myDataReportTotals: {
        totalNetValue: 0,
        totalVatValue: 0,
        totalValue: 0,
        totalCount: 0,
        totalNetValueMyData: 0,
        totalVatValueMyData: 0,
        totalValueMyData: 0,
        totalCountMyData: 0,
    },

    // Supplier Payments Report
    supplierPaymentsReportRequestData: {},
    supplierPaymentsReportResponseData: {},

    // Buys Graphic Report
    buysGraphicReportRequestData: {},
    buysGraphicReportResponseData: {},

    // Classifications Report
    classificationsReportFrom: "",
    classificationsReportRequestData: {
        firstLoad: true,
        page: 1,
        date_from: moment().startOf("month").format("DD/MM/YYYY"),
        date_to: moment().endOf("month").format("DD/MM/YYYY"),
        classificationType: [],
        type: "",
    },
    classificationsReportResponseData: {
        data: [],
        totalPages: 0,
        lastUpdate: "",
        totals: {
            myDataValue: 0,
            erpValue: 0,
            difference: 0,
        }
    },
}

export const BuysSlice = createSlice({
    name: "Buys",
    initialState,
    reducers: {
        setNewBuys: (state, {payload}) => {
            state.newBuys = payload;
        },
        setNewBuyAutofill: (state, {payload}) => {
            state.newBuyAutofill = payload;
        },
        setNewBuysNewProduct: (state, {payload}) => {
            state.newBuysNewProduct = payload;
        },
        setNewBuysExtraData: (state, {payload}) => {
            state.newBuys.extraData = {...state.newBuys.extraData, ...payload};
        },
        resetNewBuys: (state) => {
            state.newBuys = state.newBuysInitialValue;
        },
        setBuysTemplates: (state, {payload}) => {
            state.buysTemplates = payload;
        },
        setEditBuys: (state, {payload}) => {
            state.editBuys = payload;
        },
        setEditBuysNewProduct: (state, {payload}) => {
            state.editBuysNewProduct = payload;
        },
        setSearchBuys: (state, {payload}) => {
            state.searchBuys = payload;
        },
        setTotalItemsBS: (state, {payload}) => {
            state.totalItemsBS = payload;
        },
        setPerPageBS: (state, {payload}) => {
            state.perPageBS = payload;
        },
        setCorelatedDocumentsList: (state, {payload}) => {
            state.corelatedDocumentsList = payload;
        },
        setNewBuySupplierCustomData: (state, {payload}) => {
            state.newBuySupplierCustomData = payload;
        },
        setEditBuySupplierCustomData: (state, {payload}) => {
            state.editBuySupplierCustomData = payload;
        },

        // Buys Monthly Turnover Report
        initBuysMonthlyTurnoverReport: (state, {payload}) => {
            state.buysMonthlyTurnoverReportData[payload.tabKey] = {...initBuysMonthlyTurnoverResponseData};
            state.buysMonthlyTurnoverReportRequestData[payload.tabKey] = {...initBuysMonthlyTurnoverRequestData};
        },
        setBuysMonthlyTurnoverReportData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.buysMonthlyTurnoverReportData[tabKey] = action.payload;
        },
        setBuysMonthlyTurnoverReportRequestData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.buysMonthlyTurnoverReportRequestData[tabKey] = action.payload;
        },

        // Buys Balance Sheet
        initBuysBalanceReport: (state, {payload}) => {
            state.buysBalanceReportRequestData[payload.tabKey] = {...initBuysBalanceSheetRequestData};
            state.buysBalanceReportData[payload.tabKey] = [];
        },
        setBuysReportRequestData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.buysBalanceReportRequestData[tabKey] = action.payload;
        },
        setBuysReportData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.buysBalanceReportData[tabKey] = action.payload;
        },

        // Buys My Data Report
        setForceRefreshBuysMyDataReport: (state, {payload}) => {
            state.forceRefreshMyDataBuysReport = payload;
        },
        setBuysMyDataReportRequestData: (state, {payload}) => {
            state.myDataReportRequestData = payload;
        },
        setBuysMyDataReportData: (state, {payload}) => {
            state.buysMyDataReportData = payload;
        },
        setBuysMyDataReportSuppliersData: (state, {payload}) => {
            state.buysMyDataReportSuppliersData = payload;
        },
        setBuysMyDataReportTotals: (state, {payload}) => {
            state.myDataReportTotals = payload;
        },

        // Supplier Payments Report
        initSupplierPaymentReport: (state, {payload}) => {
            state.supplierPaymentsReportRequestData[payload.tabKey] = {...initSupplierPaymentReportRequestData};
            state.supplierPaymentsReportResponseData[payload.tabKey] = {...initSupplierPaymentReportResponseData};
        },
        setSupplierPaymentsReportRequestData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.supplierPaymentsReportRequestData[tabKey] = action.payload;
        },
        setSupplierPaymentsReportResponseData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.supplierPaymentsReportResponseData[tabKey] = action.payload;
        },

        // Buys Graphic Report
        initBuysGraphicReport: (state, {payload}) => {
            state.buysGraphicReportRequestData[payload.tabKey] = {...initBuysGraphicReportRequestData};
            state.buysGraphicReportResponseData[payload.tabKey] = {...initBuysGraphicReportResponseData};
        },
        setBuysGraphicReportRequestData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.buysGraphicReportRequestData[tabKey] = action.payload;
        },
        setBuysGraphicReportResponseData: (state, action) => {
            const tabKey = action.meta.tabKey;
            state.buysGraphicReportResponseData[tabKey] = action.payload;
        },

        // Classifications Report
        setClassificationsReportFrom: (state, {payload}) => {
            state.classificationsReportFrom = payload;
        },
        setClassificationsReportRequestData: (state, {payload}) => {
            state.classificationsReportRequestData = payload;
        },
        setClassificationsReportResponseData: (state, {payload}) => {
            state.classificationsReportResponseData = payload;
        },
    },
});

export const {
    setNewBuys,
    setNewBuyAutofill,
    setBuysTemplates,
    resetNewBuys,
    setNewBuysExtraData,
    setNewBuysNewProduct,
    setSearchBuys,
    setPerPageBS,
    setTotalItemsBS,
    setEditBuys,
    setEditBuysNewProduct,
    setNewBuySupplierCustomData,
    setEditBuySupplierCustomData,

    // Buys Monthly Turnover Report
    initBuysMonthlyTurnoverReport,
    setBuysMonthlyTurnoverReportData,
    setBuysMonthlyTurnoverReportRequestData,

    // Buys Balance sheet
    initBuysBalanceReport,
    setBuysReportRequestData,
    setBuysReportData,

    // Buys My Data Report
    setForceRefreshBuysMyDataReport,
    setBuysMyDataReportRequestData,
    setBuysMyDataReportTotals,
    setBuysMyDataReportData,
    setBuysMyDataReportSuppliersData,

    // Supplier Payments Report
    initSupplierPaymentReport,
    setSupplierPaymentsReportRequestData,
    setSupplierPaymentsReportResponseData,

    // Buys Graphic Report
    initBuysGraphicReport,
    setBuysGraphicReportRequestData,
    setBuysGraphicReportResponseData,

    // Classifications Report
    setClassificationsReportFrom,
    setClassificationsReportRequestData,
    setClassificationsReportResponseData,
} = BuysSlice.actions;
